module.exports = '4.8.3';



// WEBPACK FOOTER //
// ./src/version.js